import { AxiosError } from 'axios';

export function getApiErrorMessage(error: unknown): string {
    if (error instanceof AxiosError) {
        if (error.message === 'Network Error') {
            return 'Network error: unable to connect to the server.';
        }

        const status = error.response?.status;

        switch (status) {
            case 400:
                return 'Invalid request.';
            case 401:
                return 'Unauthorized.';
            case 403:
                return 'Permission denied.';
            case 404:
                return 'Resource not found.';
            case 409:
                return 'Conflict with existing data.';
            case 422:
                return 'Invalid data provided.';
            case 429:
                return 'Too many requests. Please try again later.';
            case 500:
            case 502:
            case 503:
                return 'Server error. Please try again later.';
            default:
                return `Request failed with status ${status}.`;
        }
    }

    return 'An error occurred. Please try again.';
}
